import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {email, translate} from 'admin-on-rest';
import {refreshView as refreshViewAction} from 'admin-on-rest/lib/actions/uiActions';
import {RESOURCES as loyaltyResources} from '../fuseLoyaltyResourceMap';
import Config from '../messages';
import LoyaltyAccountPointEdit from './LoyaltyAccountPointEdit';
import {createUpsertPayload} from '../restClientPreProcess';
import {generateUUID} from '../shared/functions';
import {getPostHeaders, isLocalhost, setSystemToLowercase} from '../shared/serverFunctions';
import {renderTextInput} from '../shared/formFunctions';
// import TooltipIcon from './TooltipIcon';
// import ReactTooltip from 'react-tooltip';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import {commonStyles} from '../shared/styles';
import {viewStyles} from '../shared/styles-view';
import axios from "axios";
import jwt_decode from "jwt-decode";

/**
 * A component for allowing editing of Loyalty Account fields by a Sysadmin.
 *
 */
class LoyaltyAccountAccessFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accessLoginMessage: null,
            allowFieldAccess: false,
            displayLoader: false,
            loggedInToken: null,
            loggedInWithAccess: false,
            needToRefresh: false,
            open: false,
            screen: 'login',
            submitting: false
        };
    }

    componentWillMount() {
        this.checkAccess();
    }

    /**
     * Check Loyalty access for currently logged-in user
     */
    checkAccess = () => {
        const isSysop = localStorage.getItem('sys_op');
        const isSysadmin = localStorage.getItem('sys_admin');
        const sectionsAll = localStorage.getItem('sections_all');
        const sections = JSON.parse(localStorage.getItem('sections'));
        let allowFieldAccess = false;
        if (isSysop === 'true' || isSysadmin === 'true' || sectionsAll === 'true') {
            // Sysops, Sysadmins, and Users with all sections may edit fields
            allowFieldAccess = true;
        } else if (sections && sections.length > 0) {
            // Sysusers must have admin access or specific sections to access fields
            if (
                sections.findIndex(s => s === 'admin') !== -1 ||
                sections.findIndex(s => s === 'loyalty_all') !== -1
            ) {
                allowFieldAccess = true;
            }
        }
        this.setState({
            allowFieldAccess: allowFieldAccess
        });
    };

    /**
     * Handle login submission from dialog
     *
     * @param loyalty_override_email
     * @param loyalty_override_password
     */
    loginSubmit = ({loyalty_override_email, loyalty_override_password}) => {

        // Set Authorization URI to relative unless developing locally
        let loggedInWithAccess = false;
        const endpoint = Config.fuse.api.AUTH_ENDPOINT;
        const uri = (isLocalhost) ? Config.fuse.api.LOCAL_AUTH_URI + endpoint : endpoint;
        const payload = {
            "payload": {
                "systemUserDataModel": {
                    email: loyalty_override_email,
                    password: loyalty_override_password
                }
            }
        };
        this.setState({
            submitting: true
        });

        axios
            .post(uri, payload)
            .then((result) => {
                if (result.data.payload) {
                    // Check the token and user object if available
                    const token = result.data.payload.token;
                    if (token) {
                        const decodedToken = jwt_decode(token);
                        if (decodedToken.data) {
                            // If user is Sysop, Sysadmin, or has all sections:
                            if (decodedToken.data.sys_op || decodedToken.data.sys_admin || decodedToken.data.sections_all) {
                                loggedInWithAccess = true;
                            }
                            // If user has admin access or specific sections:
                            if (decodedToken.data.sections && decodedToken.data.sections.length > 0) {
                                if (
                                    decodedToken.data.sections.findIndex(s => s === 'admin') !== -1 ||
                                    decodedToken.data.sections.findIndex(s => s === 'loyalty_all') !== -1
                                ) {
                                    loggedInWithAccess = true;
                                }
                            }
                        }
                        if (loggedInWithAccess) {
                            this.setState({
                                accessLoginMessage: null,
                                loggedInToken: token,
                                loggedInWithAccess: loggedInWithAccess,
                                screen: 'edit',
                                submitting: false
                            });
                        } else {
                            this.accessLoginFailed('Sorry, this user does not have access to adjust Points. Please cancel or log in with other credentials.');
                        }
                    } else {
                        this.accessLoginFailed('This user\'s login failed: No token available.');
                    }
                } else {
                    this.accessLoginFailed('This user\'s login failed: No token available.');
                }
            })
            .catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    let payload = error.response.data.payload;
                    let message = error.response.data.message;
                    let error_message = error.response.data.error_message;

                    if (payload && payload.indexOf('password') !== -1) {
                        this.accessLoginFailed('Incorrect credentials.');
                    } else if (message) {
                        this.accessLoginFailed(message);
                    } else if (error_message) {
                        this.accessLoginFailed(error_message);
                    } else {
                        this.accessLoginFailed('Login failed.');
                    }
                } else if (error.request) {
                    // No response
                    this.accessLoginFailed('No response from server.');
                } else {
                    this.accessLoginFailed('No response from server.');
                }
            });
    };

    /**
     * Display error notification
     */
    accessLoginFailed = (message) => {
        this.setState({
            accessLoginMessage: message,
            submitting: false
        });
    };

    submitOverride = () => {
        const loyaltyAccessForm = this.props.loyaltyAccessForm;
        const recordForm = JSON.parse(JSON.stringify(this.props.recordForm));

        // Set params from Create/Edit form and from override form
        const params = {
            data: recordForm
        };
        params.data.is_creating = (this.props.formType === 'create');
        params.data.rank_points = (loyaltyAccessForm.rank_points) ? loyaltyAccessForm.rank_points : recordForm.rank_points;
        params.data.reward_points = (loyaltyAccessForm.reward_points) ? loyaltyAccessForm.reward_points : recordForm.reward_points;
        params.data.system = setSystemToLowercase();

        // Get resource and headers
        let resource = (this.props.formType === 'create')
            ? loyaltyResources.LoyaltyAccounts.CREATE(params)
            : loyaltyResources.LoyaltyAccounts.UPDATE(params);
        let headers = getPostHeaders();

        // Update Authorization header with the override token
        headers.Authorization = 'Bearer ' + this.state.loggedInToken;

        // Create a payload for upserting
        let payload = createUpsertPayload('LoyaltyAccounts');
        payload.pkg_uuid = generateUUID();
        payload.payload.model = resource.data;

        axios({
            method: 'post',
            url: resource.uri,
            data: payload,
            headers: headers
        }).then((result) => {
            if (result.data.payload) {
                this.setState({
                    needToRefresh: true,
                    screen: 'success'
                });
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                needToRefresh: false,
                screen: 'failed'
            });
        });
    };

    handleFormChange = (e, field) => {
        const value = (e.currentTarget && e.currentTarget.value) ? e.currentTarget.value : 0;
        if (this.state.allowFieldAccess) {
            // Fields were updated in normal Create/Edit form, so pass values to that form
            this.props.dispatch(change('record-form', field, value));
        } else if (this.state.loggedInWithAccess) {
            // Fields were updated in a modal with separate access, no action
        }
    };

    handleFormButtons = (e, type) => {
        if (type === 'cancel') {
            this.handleClose();
        }
        if (type === 'submit') {
            this.submitOverride();
        }
    };

    handleOpen = () => {
        this.props.dispatch(change('loyaltyAccessForm', 'loyalty_override_email', ''));
        this.props.dispatch(change('loyaltyAccessForm', 'loyalty_override_password', ''));
        this.setState({
            accessLoginMessage: null,
            displayLoader: false,
            loggedInWithAccess: false,
            needToRefresh: false,
            open: true,
            screen: 'login',
            submitting: false
        });
    };

    handleClose = () => {
        this.props.dispatch(change('loyaltyAccessForm', 'rank_points', 0));
        this.props.dispatch(change('loyaltyAccessForm', 'reward_points', 0));
        this.setState({
            accessLoginMessage: null,
            displayLoader: false,
            loggedInWithAccess: false,
            open: false,
            screen: 'login',
            submitting: false
        }, () => {
            if (this.state.needToRefresh) {
                this.props.refreshView();
            } else {
            }
        });
    };

    render() {

        const {
            formType,
            handleSubmit,
            recordForm
        } = this.props;

        const {
            accessLoginMessage,
            allowFieldAccess,
            screen
        } = this.state;

        const styles = {
            dialogContent: {maxWidth: 600},
            input: {display: 'flex'},
            form: {padding: '0 1em 1em 1em'},
        };

        return (
            <div className="loyalty-field-access">
                {this.state.displayLoader &&
                <div style={commonStyles.loaderContainer}>
                    <h4>Retrieving Systems...</h4>
                    <CircularProgress
                        size={24}
                        thickness={2}
                        className="loader"
                    />
                </div>
                }

                {/* Edit Form: Edit Points */}
                {allowFieldAccess &&
                <div>
                    <LoyaltyAccountPointEdit
                        formValues={recordForm}
                        isModal={false}
                        onFormChange={this.handleFormChange}
                    />
                </div>
                }

                {/* Button: Create Prompt */}
                {!allowFieldAccess && formType === 'create' &&
                <div>
                    <span style={{...viewStyles.fieldDescriptionTop, ...commonStyles.marginBottom}}>
                        You do not have access to add Loyalty Rank Points or Reward Points. Complete the new Loyalty
                        Account form first, then edit the Account.
                    </span>
                </div>
                }

                {/* Button: Edit Prompt */}
                {!allowFieldAccess && formType === 'edit' &&
                <div>
                    <span style={{...viewStyles.fieldDescriptionTop, ...commonStyles.marginBottom}}>
                        You do not have access to adjust Loyalty Rank Points or Reward Points. Click the button below
                        to allow a user with full Loyalty permissions to log in and make adjustments.
                    </span>
                    <RaisedButton
                        type="button"
                        primary
                        label="Edit Loyalty Rank and Reward Points"
                        onClick={this.handleOpen}
                    />
                </div>
                }

                <Dialog
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                    contentStyle={styles.dialogContent}
                >
                    <div style={styles.dialogContent}>

                        {/* Dialog Screen: Login */}
                        {screen === 'login' &&
                        <div>
                            <form onSubmit={handleSubmit(this.loginSubmit)}>
                                <div style={styles.form}>
                                    <p>
                                        Login with credentials for a Sysadmin or an Admin User with full Loyalty
                                        permissions.
                                    </p>
                                    <div style={styles.input}>
                                        <Field
                                            name="loyalty_override_email"
                                            type="email"
                                            component={renderTextInput}
                                            floatingLabelText="Email"
                                            autoComplete="new-email"
                                            validate={[email]}
                                        />
                                    </div>
                                    <div style={styles.input}>
                                        <Field
                                            name="loyalty_override_password"
                                            type="password"
                                            component={renderTextInput}
                                            floatingLabelText="Password"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                </div>
                                <RaisedButton
                                    type="submit"
                                    primary
                                    disabled={this.state.submitting}
                                    label="Sign In"
                                    fullWidth/>
                            </form>
                            {accessLoginMessage &&
                            <p>{accessLoginMessage}</p>
                            }
                        </div>
                        }

                        {/* Dialog Screen: Edit Points */}
                        {screen === 'edit' &&
                        <div>
                            <form>
                                <h4>Adjust Points</h4>
                                <LoyaltyAccountPointEdit
                                    formValues={recordForm}
                                    isModal={true}
                                    onButtonClick={this.handleFormButtons}
                                    onFormChange={this.handleFormChange}
                                />
                            </form>
                        </div>
                        }

                        {/* Dialog Screen: Edit Success */}
                        {screen === 'success' &&
                        <div>
                            <h4>Updated</h4>
                            <p>Adjustments to Rank Points and Reward Points are submitted. Close this dialog
                                to continue editing this Loyalty Account.</p>
                            <RaisedButton
                                type="button"
                                primary
                                label="Close"
                                onClick={this.handleClose}
                            />
                        </div>
                        }

                        {/* Dialog Screen: Edit Failure */}
                        {screen === 'failed' &&
                        <div>
                            <h4>Error</h4>
                            <p>Sorry, there was an error adjusting Rank Points and Reward Points for this Loyalty
                                Account. Please close this dialog and try again, or log into the CloudSent POS
                                Administration Portal with other credentials.</p>
                            <RaisedButton
                                type="button"
                                primary
                                label="Close"
                                onClick={this.handleClose}
                            />
                        </div>
                        }
                    </div>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let loyaltyAccessForm = state.form['loyaltyAccessForm'];
    let recordForm = state.form['record-form'];
    if (loyaltyAccessForm && loyaltyAccessForm.values && recordForm && recordForm.values) {
        return {
            loyaltyAccessForm: loyaltyAccessForm.values,
            recordForm: recordForm.values
        }
    }
    return {}
};
LoyaltyAccountAccessFields.propTypes = {
    formType: PropTypes.string,
    refreshView: PropTypes.func,
    user: PropTypes.object,
};

LoyaltyAccountAccessFields.defaultProps = {
    formType: 'edit',
    user: null,
};

const enhance = compose(
    translate,
    reduxForm({
        form: 'loyaltyAccessForm',
        enableReinitialize: true
    }),
    connect(mapStateToProps, {refreshView: refreshViewAction})
);

export default enhance(LoyaltyAccountAccessFields);



// WEBPACK FOOTER //
// ./src/Fuse/components/LoyaltyAccountAccessFields.js